import { graphql } from "react-relay";

export const UpdateJiraInstanceMutation = graphql`
  mutation UpdateJiraInstanceMutation($input: UpdateJiraInstanceInput!) {
    updateJiraInstance(input: $input) {
      jiraInstance {
        defaultSpace {
          key
          name
        }
        defaultWorkType {
          name
        }
        error
        id
        spaces {
          key
          name
          workTypes {
            iconUrl
            name
          }
        }
        spacesUpdated
        updatePending
        clientId
        issueLimitSoft
        issueLimitHard
        name
        url
        username
        uuid
      }
      problems {
        message
      }
    }
  }
`;
